/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Row,
  Spin,
  Col,
  Form,
  Modal,
  TreeSelect,
} from 'antd';
import { onError } from 'utils/handlers';
import { areaBuscar, normalizeData } from 'utils/normalizers';
import Table from 'components/Table';
import Select from 'components/Select';
import FormSubmitControls from 'components/FormSubmitControls';
import CurrencyInput from 'components/CurrencyInput';
import PercentageInput from 'components/PercentageInput';
import {
  PARAMETRO_AREA,
  PARAMETRO_REEMBOLSOGASTOS,
  PARAMETRO_ESPECIALES,
  ESTATUS_AUTORIZADO,
  PARAMETRO_DESTAJO,
  PARAMETRO_PUESTO,
  PARAMETRO_DEVOLUCION_DESCUENTOS_INDEBIDOS,
  PARAMETRO_RETROACTIVOS_ESPECIFICOS,
  PARAMETRO_ISR_SUBSIDIADO,
  PARAMETRO_ANTIGUEDAD,
} from 'utils/constants';
import { getDatoOperacionalesDeEmpleados } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';
import { getAreas } from 'api/catalogos';
import { getSolicitudesAreas } from 'api/nominas/solicitudes/solicitudesAreas';
import { getAdministracionDePlazas, getAdministracionDePlazasvistaOptimized } from 'api/catalogos/admnistracionDePlazas';
import { postSolicitudesPercepcionesEmpleados } from 'api/nominas/solicitudes/solicitudesPercepcionesEmpleados';
import { getPlazas, getPlazasvistaOptimized } from 'api/catalogos/plazas';
import { getPuestos } from 'api/catalogos/puestos';

const ModalSolicitudesPercepcionesEmpleados = ({
  datosOperacionales,
  empleados,
  solicitud,
  tipoNominaEmpleado,
  periodoNominaDetalle,
  solicitudPercepcion,
  solicitudesPercepcionesEmpleados,
  tipoParametro,
  percepcionFijo,
  solicitudConfig,
  importeSolicitudPagar,
  open,
  setOpen,
  puestos,
  onSave,
}) => {
  const [empleadosFiltered, setEmpleadosFiltered] = useState([]);
  const [tiposNominasEmpleados, setTiposNominasEmpleados] = useState([]);
  const [periodosNominasDetalles, setPeriodosNominasDetalles] = useState([]);
  const [areas, setAreas] = useState([]);
  const [plazas, setPlazas] = useState([]);
  const [adminPlazas, setAdminPlazas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [form] = Form.useForm();
  const [disabled, setDisabled] = useState(true);
  const [aplicaPorcentaje, setAplicaPorcentaje] = useState(true);
  const [solicitudesAreas, setSolicitudesAreas] = useState([]);

  const clamp = (num, min, max) => Math.min(Math.max(num, min), max);
  const roundNumber = (num) => Math.floor(num * 1e2) / 1e2;

  // obtener los empleados que pertenecen al tipo de nomina,
  // no cuentan con una solicitud de percepcion
  // y tienen asignada una plaza
  const filterEmpleados = (value) => {
    const id = value?.id;
    const _datosOp = datosOperacionales.find((e) => e.empleado === id);
    // eslint-disable-next-line max-len
    const _solicitudPercepcionEmpleado = solicitudesPercepcionesEmpleados.find((e) => e.solicitud_percepcion === solicitudPercepcion && e.empleado === id);
    const _adminPlaza = adminPlazas.some((e) => e.empleado_id === id);
    return (_datosOp?.tipo_de_nomina_empleado === tipoNominaEmpleado)
      && !_solicitudPercepcionEmpleado && _adminPlaza;
  };
  const filterPorArea = (areaId) => {
    // Filtramos directamente por adminPlazas usando directorio_area_id
    const _adminPlazas = adminPlazas.filter(
      (adminPlaza) => adminPlaza.directorio_area_id === areaId,
    );

    const _empleados = empleados.filter((e) => _adminPlazas.some((ap) => ap.empleado_id === e.id || ap.empleado === e.id));

    const _datosOp = datosOperacionales.filter((e) => _empleados.some((emp) => emp.id === e.empleado));

    let _empleadosFiltered = _empleados.filter((e) => _datosOp.some(
      (dp) => e.id === dp.empleado
        && dp.tipo_de_nomina_empleado === tipoNominaEmpleado,
    ));

    _empleadosFiltered = _empleadosFiltered.sort((a, b) => a.id - b.id);

    return _empleadosFiltered;
  };

  const filterPorPuesto = (puestoId) => {
    // Filtramos en adminPlazas por puesto
    const _adminPlazas = adminPlazas.filter(
      (adminPlaza) => adminPlaza.puesto_id === puestoId,
    );

    const _empleados = empleados.filter((e) => _adminPlazas.some((ap) => ap.empleado_id === e.id));

    const _datosOp = datosOperacionales.filter((e) => _empleados.some((emp) => emp.id === e.empleado));

    let _empleadosFiltered = _empleados.filter((e) => _datosOp.some(
      (dp) => dp.empleado === e.id
        && dp.tipo_de_nomina_empleado === tipoNominaEmpleado,
    ));

    _empleadosFiltered = _empleadosFiltered.sort((a, b) => a.id - b.id);

    return _empleadosFiltered;
  };

  const normalizeDataAreas = (_areasFetchArray) => {
    const mainMap = new Map();
    _areasFetchArray.forEach((item) => {
      mainMap.set(item.id, { ...item, children: [] });
    });

    const result = [];

    _areasFetchArray.forEach((item) => {
      if (item.directorio_area_padre) {
        const parent = mainMap.get(item.directorio_area_padre);
        if (parent) {
          parent.children.push(mainMap.get(item.id));
        }
      } else {
        result.push(mainMap.get(item.id));
      }
    });

    const sortByClave = (nodes) => {
      nodes.sort((a, b) => a.clave.localeCompare(b.clave));
      nodes.forEach((node) => {
        if (node.children && node.children.length > 0) {
          sortByClave(node.children);
        }
      });
    };

    sortByClave(result);

    return result;
  };

  // Esta función adapta el árbol para que funcione con TreeSelect
  const formatTreeSelectData = (nodes) => nodes.map((node) => ({
    title: `${node.clave} - ${node.nombre.trim()}`,
    value: node.id,
    children: node.children ? formatTreeSelectData(node.children) : [],
  }));

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _tiposNominasEmpleados,
        _periodosNominasDetalles,
        _areas,
        _plazas,
        _adminPlazas,
        _solicitudesAreas,

      ] = await Promise.all([
        getTiposDeNominasEmpleados({ estados_globales: ESTATUS_AUTORIZADO }),
        getPeriodosDeNominasDetalles(),
        getAreas({ estados_globales: ESTATUS_AUTORIZADO }),
        getPlazasvistaOptimized(),
        getAdministracionDePlazasvistaOptimized(),
        getSolicitudesAreas({ solicitud }),

      ]);
      const formattedURS = normalizeDataAreas(_areas);
      const formattedTreeData = formatTreeSelectData(formattedURS);
      // const formattedURs = normalizeData(_areas);
      if (mounted) {
        setTiposNominasEmpleados(_tiposNominasEmpleados);
        setPeriodosNominasDetalles(_periodosNominasDetalles);
        setAreas(formattedTreeData);
        setPlazas(_plazas || []);
        setAdminPlazas(_adminPlazas || []);
        setSolicitudesAreas(_solicitudesAreas);
      }
      setLoading(false);
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  useEffect(() => {
    setLoading(true);
    let _empleados = empleados;
    if (tipoParametro === PARAMETRO_AREA) {
      setEmpleadosFiltered([]);
    } else {
      if (tipoParametro === PARAMETRO_ANTIGUEDAD) {
        const idsValidos = new Set(
          datosOperacionales
            ?.filter((d) => Number(d.antiguedad_numerico_dias) >= 1825)
            .map((d) => d.empleado),
        );
        _empleados = empleados.filter((e) => idsValidos.has(e.id));
      }
      if (solicitudConfig?.importe_limite_maximo_sueldo > 0) {
        const idsValidos = new Set(
          datosOperacionales
            ?.filter((d) => Number(d.sueldo_mensual) <= 17458)
            .map((d) => d.empleado),
        );
        _empleados = _empleados.filter((e) => idsValidos.has(e.id));
      }
      const _empleadosFiltered = _empleados?.filter(filterEmpleados)
        .sort((a, b) => a.id - b.id);
      setEmpleadosFiltered(_empleadosFiltered);
    }
    setLoading(false);
  }, [empleados, solicitudesPercepcionesEmpleados, tipoNominaEmpleado]);

  const cols = [
    {
      titleText: 'No. y Nombre de Empleado',
      dataIndex: 'no_y_nombre_empleado',
      key: 'no_y_nombre_empleado',
      width: 200,
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_nomina_empleado',
      key: 'tipo_nomina_empleado',
      width: 150,
      render: () => {
        const _tipoNominaEmpleado = tiposNominasEmpleados.find((e) => e.id === tipoNominaEmpleado);
        return _tipoNominaEmpleado?.descripcion;
      },
    },
    {
      titleText: tipoParametro === PARAMETRO_PUESTO ? 'Puesto' : 'Área',
      dataIndex: 'area',
      key: 'area_o_puesto',
      width: 170,
      render: (_, record) => {
        const _adminPlaza = adminPlazas?.find(
          (adminPlaza) => adminPlaza?.empleado_id === record.id,
        );

        if (!_adminPlaza) return '—';

        // Si es parámetro PUESTO, mostrar puesto
        if (tipoParametro === PARAMETRO_PUESTO) {
          const plaza = plazas?.find((p) => p.id === _adminPlaza.plaza_id);
          if (!plaza) return '—';

          // Si tienes ambos: ID y nombre de puesto
          return plaza.puesto
            ? `${plaza.puesto_id || ''} - ${plaza.puesto}`
            : '—';
        }

        // Caso normal: mostrar área
        return _adminPlaza.directorio_area || '—';
      },
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_nomina_empleado',
      key: 'tipo_nomina_empleado',
      width: 150,
      render: () => {
        const _tipoNominaEmpleado = tiposNominasEmpleados.find((e) => e.id === tipoNominaEmpleado);
        return _tipoNominaEmpleado?.descripcion;
      },
    },
    {
      titleText: 'Antigüedad',
      dataIndex: 'antiguedad_texto',
      key: 'antiguedad_texto',
      width: 200,
    },
    {
      titleText: 'No. de Días',
      dataIndex: 'antiguedad_numerico_dias',
      key: 'antiguedad_numerico_dias',
      width: 200,
      render: (value) => Number(value).toLocaleString('es-MX'),
    },
  ];

  // eslint-disable-next-line no-unused-vars
  const handleSelectAll = (selected, selectedRows, changeRows) => {
    if (selected) {
      // Si el usuario marca el check de "Todos":
      // Mapeamos DIRECTAMENTE sobre 'empleadosFiltered' para obtener todos los IDs,
      // ignorando la paginación actual.
      const allIds = empleadosFiltered.map((row) => row.id);
      setSelectedRowKeys(allIds);
    } else {
      // Si el usuario desmarca el check, limpiamos la selección
      setSelectedRowKeys([]);
    }
  };

  const handleOnRowClick = (record) => {
    if (selectedRowKeys.includes(record.id)) {
      setSelectedRowKeys(selectedRowKeys.filter((id) => id !== record.id));
    } else {
      setSelectedRowKeys([...selectedRowKeys, record.id]);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onSelectAll: handleSelectAll,
    type: 'checkbox',
  };

  const onCancel = () => {
    setSelectedRowKeys([]);
    setOpen(false);
    setAplicaPorcentaje(true);
    setDisabled(true);
    form.resetFields();
  };

  const formInstances = [
    form,
  ];

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      const formValues = form.getFieldsValue();
      delete formValues.area;
      delete formValues.puesto;
      const values = selectedRowKeys.map((val) => ({
        empleado_id: val,
        solicitud_percepcion_id: solicitudPercepcion,
        ...formValues,
      }));
      const saved = await postSolicitudesPercepcionesEmpleados(values);
      if (saved) {
        if (_continue) {
          if (onSave) onSave();
        } else {
          onCancel();
          if (onSave) onSave();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    importe_de_solicitud: [
      requiredRule,
      {
        validator: async (rule, value) => {
          if (typeof value === 'number') {
            if (value === 0 || value < 0.01) {
              throw new Error('El importe debe ser mayor a 0');
            }
          }
        },
      },
    ],
    porcentaje_de_pago: [
      requiredRule,
      {
        validator: async (rule, value) => {
          if (typeof value === 'number') {
            if (value === 0 || value < 0.01) {
              throw new Error('El porcentaje debe ser mayor a 0');
            }
            if (value >= 100) {
              throw new Error('El porcentaje debe ser menor a 100');
            }
          }
        },
      },
    ],
    importe_de_solicitud_a_pagar: [
      {
        validator: async (rule, value) => {
          if (value === 0) {
            throw new Error('El importe a pagar debe ser mayor a 0');
          }
        },
      },
    ],
  };

  return (
    <Modal
      open={open}
      closable={false}
      maskClosable={!loading}
      keyboard={!loading}
      footer={null}
      title={(
        <FormSubmitControls
          label="Agregar Empleados"
          onFinish={onFinish}
          onCancel={onCancel}
          allowSave={selectedRowKeys.length}
        />
      )}
      onCancel={onCancel}
      forceRender
      width="60%"
    >
      <Spin tip="Cargando..." spinning={loading}>
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          scrollToFirstError
          name="general"
          initialValues={{
            aplica_porcentaje_de_pago: false,
          }}
        >
          <Row gutter={10}>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                label="Tipo de Nómina Empleado"
              >
                <Select
                  keyProp="id"
                  labelProp="descripcion"
                  dataSource={tiposNominasEmpleados}
                  value={tipoNominaEmpleado}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                label="Periodo de Pago"
              >
                <Select
                  keyProp="id"
                  labelProp="numero_de_nomina"
                  dataSource={periodosNominasDetalles}
                  value={periodoNominaDetalle}
                  render={(value) => `${value?.numero_de_nomina} (${value.fecha_inicial} al ${value.fecha_final})`}
                  disabled
                />
              </Form.Item>
            </Col>
            {tipoParametro === PARAMETRO_ESPECIALES || tipoParametro === PARAMETRO_DESTAJO
              ? (
                <>
                  <Col xs={24} sm={24} md={8}>
                    <CurrencyInput
                      name="importe_de_solicitud"
                      label="Importe de Solicitud"
                      precision={2}
                      // rules={rules.importe_de_solicitud}
                      onChange={(value) => {
                        if (percepcionFijo === false) {
                          form.setFieldValue('importe_de_solicitud_a_pagar', value);
                        }
                      }}
                    />
                  </Col>
                  <Col>
                    <CurrencyInput
                      name="importe_de_solicitud_a_pagar"
                      label="Importe de Solicitud a Pagar"
                      hidden
                    />
                  </Col>
                </>
              ) : null}
            {tipoParametro === PARAMETRO_AREA
              ? (
                <>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="area"
                      label="Área"
                      rules={rules.required}
                    >
                      <TreeSelect
                        showSearch
                        treeNodeFilterProp="title"
                        treeData={areas}
                        onChange={(value) => {
                          setSelectedRowKeys([]);
                          if (value) {
                            setLoading(true);
                            const _empleadosPorArea = filterPorArea(value);
                            setEmpleadosFiltered(_empleadosPorArea);
                            setLoading(false);
                            if (percepcionFijo) {
                              form.setFieldValue('importe_de_solicitud', importeSolicitudPagar);
                              form.setFieldValue('importe_de_solicitud_a_pagar', importeSolicitudPagar);
                            }
                          } else {
                            setEmpleadosFiltered([]);
                          }
                        }}
                      />
                      {/* <Select
                        keyProp="id"
                        dataSource={areas}
                        // render={(value) => normalizeDataAreas(value?.directorio_de_area, areas)?.tableTitle}
                        // onChange={(value) => {
                        //   setSelectedRowKeys([]);
                        //   if (value) {
                        //     setLoading(true);
                        //     const _solicitudArea = solicitudesAreas.find((x) => x.id === value);
                        //     const _area = _solicitudArea?.directorio_de_area;
                        //     const _empleadosPorArea = filterPorArea(_area);
                        //     setEmpleadosFiltered(_empleadosPorArea);
                        //     setLoading(false);
                        //     if (percepcionFijo) {
                        //       form.setFieldValue('importe_de_solicitud', importeSolicitudPagar);
                        //       form.setFieldValue('importe_de_solicitud_a_pagar', importeSolicitudPagar);
                        //     }
                        //   } else {
                        //     setEmpleadosFiltered([]);
                        //   }
                        // }}
                      /> */}
                    </Form.Item>
                  </Col>
                  {/* <Col xs={24} sm={24} md={8}>
                    <CurrencyInput
                      name="importe_de_solicitud"
                      label="Importe de Solicitud"
                      precision={2}
                      disabled={percepcionFijo}
                      // rules={rules.importe_de_solicitud}
                      onChange={(value) => {
                        if (percepcionFijo === false) {
                          form.setFieldValue('importe_de_solicitud_a_pagar', value);
                        }
                      }}
                    />
                  </Col> */}
                  <Col>
                    <CurrencyInput
                      name="importe_de_solicitud_a_pagar"
                      label="Importe de Solicitud a Pagar"
                      hidden
                    />
                  </Col>
                </>
              ) : null}
            {tipoParametro === PARAMETRO_PUESTO ? (
              <>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="puesto"
                    label="Puesto"
                    rules={rules.required}
                  >
                    <Select
                      keyProp="id"
                      labelProp="descripcion" // o nombre si así viene
                      dataSource={puestos}
                      onChange={(value) => {
                        setSelectedRowKeys([]);
                        if (value) {
                          setLoading(true);
                          const _empleadosPorPuesto = filterPorPuesto(value);
                          setEmpleadosFiltered(_empleadosPorPuesto);
                          setLoading(false);

                          if (percepcionFijo) {
                            form.setFieldValue('importe_de_solicitud', importeSolicitudPagar);
                            form.setFieldValue('importe_de_solicitud_a_pagar', importeSolicitudPagar);
                          }
                        } else {
                          setEmpleadosFiltered([]);
                        }
                      }}
                    />
                  </Form.Item>
                </Col>

                {/* {<Col xs={24} sm={24} md={8}>
                  <CurrencyInput
                    name="importe_de_solicitud"
                    label="Importe de Solicitud"
                    precision={2}
                    disabled={percepcionFijo}
                    onChange={(value) => {
                      if (!percepcionFijo) {
                        form.setFieldValue('importe_de_solicitud_a_pagar', value);
                      }
                    }}
                  />
                </Col>} */}

                <Col>
                  <CurrencyInput
                    name="importe_de_solicitud_a_pagar"
                    label="Importe de Solicitud a Pagar"
                    hidden
                  />
                </Col>
              </>
            ) : null}

            {tipoParametro === PARAMETRO_REEMBOLSOGASTOS
              ? (
                <>
                  <Col xs={24} sm={24} md={8}>
                    <CurrencyInput
                      name="importe_de_solicitud"
                      label="Importe de Solicitud"
                      rules={rules.importe_de_solicitud}
                      precision={2}
                      onChange={(value) => {
                        if (percepcionFijo === false) {
                          if (typeof value === 'number') {
                            setDisabled(false);
                            const rounded = roundNumber(value);
                            if (form.getFieldValue('aplica_porcentaje_de_pago') === true) {
                              const porcentajePago = clamp(form.getFieldValue('porcentaje_de_pago'), 0, 100);
                              // eslint-disable-next-line max-len
                              const importePagar = roundNumber((rounded * porcentajePago) / 100);
                              form.setFieldValue('importe_de_solicitud_a_pagar', importePagar);
                            } else {
                              form.setFieldValue('importe_de_solicitud_a_pagar', rounded);
                            }
                          }
                        }
                      }}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="aplica_porcentaje_de_pago"
                      label="Aplica Porcentaje de Pago"
                      hasFeedback
                      rules={!disabled ? rules.required : null}
                    >
                      <Select
                        trueFalse
                        onChange={(value) => {
                          if (!value) {
                            form.resetFields(['porcentaje_de_pago']);
                            form.setFieldsValue({
                              importe_de_solicitud_a_pagar: form.getFieldValue('importe_de_solicitud'),
                            });
                          }
                          setAplicaPorcentaje(!value);
                        }}
                        disabled={disabled}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <PercentageInput
                      name="porcentaje_de_pago"
                      label="Porcentaje de Pago"
                      rules={!aplicaPorcentaje ? rules.porcentaje_de_pago : ''}
                      disabled={aplicaPorcentaje}
                      precision={2}
                      onChange={(value) => {
                        if (typeof value === 'number') {
                          const rounded = roundNumber(value);
                          const porcentajePago = Math.min(rounded, 100);
                          const importeSolicitud = form.getFieldValue('importe_de_solicitud');
                          // eslint-disable-next-line max-len
                          const importePagar = roundNumber((importeSolicitud * porcentajePago) / 100);
                          form.setFieldValue('importe_de_solicitud_a_pagar', importePagar);
                        }
                      }}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <CurrencyInput
                      name="importe_de_solicitud_a_pagar"
                      label="Importe de Solicitud a Pagar"
                      rules={rules.importe_de_solicitud_a_pagar}
                      disabled
                    />
                  </Col>
                </>
              ) : null}
            {tipoParametro !== PARAMETRO_ESPECIALES || tipoParametro !== PARAMETRO_DESTAJO || tipoParametro !== PARAMETRO_REEMBOLSOGASTOS
              ? (
                <Col xs={24} sm={24} md={8}>
                  <CurrencyInput
                    name="importe_de_solicitud"
                    label="Importe de Solicitud"
                    precision={2}
                    disabled={percepcionFijo}
                    onChange={(value) => {
                      if (!percepcionFijo) {
                        form.setFieldValue('importe_de_solicitud_a_pagar', value);
                      }
                    }}
                  />
                </Col>
              ) : null}
            <Col>
              <Table
                cols={cols}
                data={empleadosFiltered}
                rowSelection={rowSelection}
                handleOnRowClick={handleOnRowClick}
                allowSearch
                allowExportParam={false}
                allowColumnSelector={false}
              />
            </Col>
          </Row>
        </Form>
      </Spin>
    </Modal>
  );
};

export default ModalSolicitudesPercepcionesEmpleados;
